import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import AppProvider from "@/contexts/AppProvider.tsx";
import App from "./App.tsx";
import { isInternalTraffic, markInternalTraffic, removeDefaultMetaTags } from "@/helpers/helpers";
import initSentry from "@/helpers/initSentry";
import initClarity from "@/helpers/initClarity";
import ga from "@/utils/ga";
import { VITE_MODES } from "@shared/config/constants.js";

removeDefaultMetaTags();
markInternalTraffic();
ga.updateConsentForInternalTraffic();

const isLocalMode = import.meta.env.MODE === VITE_MODES.LOCAL;
const isProduction = import.meta.env.PROD;

initSentry({ enabled: !isLocalMode });
initClarity({ enabled: isProduction && !isInternalTraffic() });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>,
);
